import React from 'react';
import ImageLoader from '../images/ImageLoader';
import Modal from '../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';

var BonusRewardCardModal = function BonusRewardCardModal(props) {
  var _Instructions$value;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide,
      cta = props.cta,
      _props$releaseRedempt = props.releaseRedemptionEngineV2,
      releaseRedemptionEngineV2 = _props$releaseRedempt === void 0 ? false : _props$releaseRedempt,
      _props$rewardBadgeTex = props.rewardBadgeText,
      rewardBadgeText = _props$rewardBadgeTex === void 0 ? null : _props$rewardBadgeTex;
  var Image = model.Image,
      Name = model.Name,
      DisplayName = model.DisplayName,
      Description = model.Description,
      Instructions = model.Instructions,
      Expiration = model.Expiration;
  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--bonus-reward-card',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  }), releaseRedemptionEngineV2 && (Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) && rewardBadgeText && rewardBadgeText !== '' && ['App Only', 'Online Only', 'In-Store Only', 'Retail Only'].includes(Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) && /*#__PURE__*/React.createElement("div", {
    className: "cb-bonus-reward-card-modal__tag cb-bonus-reward-card-modal__tag--".concat(Instructions === null || Instructions === void 0 ? void 0 : (_Instructions$value = Instructions.value) === null || _Instructions$value === void 0 ? void 0 : _Instructions$value.toLowerCase().replace(/\s/g, '-'))
  }, rewardBadgeText)), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__body-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-bonus-reward-card-modal__body-container__info',
    field: Name
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-bonus-reward-card-modal__body-container__header',
    field: DisplayName
  }), /*#__PURE__*/React.createElement(RichText, {
    field: Description,
    tag: "span",
    className: 'cb-bonus-reward-card-modal__body-container__copy'
  }), releaseRedemptionEngineV2 && Expiration.value && /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card-modal__body-container__expiration'
  }, "Expires ".concat(Expiration.value)), releaseRedemptionEngineV2 ? cta.link && cta.link !== '#' ? /*#__PURE__*/React.createElement(SitecoreLink, {
    field: {
      value: {
        href: cta.link || '#',
        text: cta.buttonText,
        title: cta.buttonText
      }
    },
    className: 'cb-button-primary cb-bonus-reward-card-modal__body-container__button'
  }) : /*#__PURE__*/React.createElement("div", {
    className: 'cb-button-primary cb-bonus-reward-card-modal__body-container__button',
    onClick: function onClick() {
      return hide();
    }
  }, cta.buttonText) : /*#__PURE__*/React.createElement(SitecoreLink, {
    field: {
      value: {
        href: cta.link || '#',
        text: cta.buttonText,
        title: cta.buttonText
      }
    },
    className: 'cb-button-primary cb-bonus-reward-card-modal__body-container__button'
  }))));
};

export default BonusRewardCardModal;